<template>
  <div
    class="flex flex-col justify-center mb-2 bg-white rounded-xl border border-gray-300 border-solid"
  >
    <div class="flex flex-col justify-center w-full rounded-xl">
      <div
        class="flex gap-10 justify-between items-center px-6 py-5 rounded-xl w-full bg-slate-50 cursor-pointer"
        @click="toggleCollapse"
      >
        <div class="flex items-center gap-2">
          <div
            class="flex items-center justify-center w-6 h-6 rounded-full bg-gray-200 text-black font-semibold text-sm"
          >
            5
          </div>
          <h3 class="text-sm font-semibold text-black">Website Url</h3>
        </div>
        <button
          class="flex justify-between items-center self-stretch my-auto w-5"
          aria-label="Toggle cards styling"
        >
          <div v-html="isCollapsed ? ARROW_DOWN : ARROW_UP"></div>
        </button>
      </div>

      <div
        class="flex flex-col w-full px-6 pb-5 rounded-xl max-md:px-5"
        v-if="!isCollapsed"
        ref="collapsible"
      >
        <div class="flex flex-col mb-4 mt-4 text-left pb-4">
          <div class="flex flex-col mb-2">
            <BaseLabel
              forAttr="websiteUrl"
              :text="`Enter the URL where this will be hosted.`"
              class="font-inter text-sm font-medium leading-normal tracking-normal mb-2"
            />
            <textarea
              v-model="localWebsiteUrl"
              @input="handleWebsiteUrlChange"
              placeholder="Type your text here..."
              class="w-full h-12 border rounded-md p-2 resize-none focus:outline-none"
              rows="2"
            ></textarea>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { ref, defineComponent } from "vue";
import BaseLabel from "@/components/shared/BaseLabel.vue";
import { ARROW_DOWN, ARROW_UP } from "@/assets/svg/shared/svg-constants";

export default defineComponent({
  name: "WebsiteDetails",
  components: {
    BaseLabel,
  },
  props: {
    websiteUrl: {
      type: String,
      required: true,
    },
    companyWebsite: {
      type: String,
      required: true,
    },
  },
  emits: ["websiteUrlChanged"],
  setup(props, { emit }) {
    const isCollapsed = ref(false);
    const localWebsiteUrl = ref(
      props.websiteUrl || `${props.companyWebsite}/experts`
    );

    const toggleCollapse = () => {
      isCollapsed.value = !isCollapsed.value;
    };

    const handleWebsiteUrlChange = () => {
      emit("websiteUrlChanged", localWebsiteUrl.value);
    };

    return {
      isCollapsed,
      toggleCollapse,
      ARROW_DOWN,
      ARROW_UP,
      handleWebsiteUrlChange,
      localWebsiteUrl,
    };
  },
});
</script>
